import { Stack, Typography } from "@mui/joy";
import { useRecoilState, useSetRecoilState } from "recoil";
import { useState } from "react";
import { taskSectionAtom } from "recoil/taskSectionAtom";
import * as _ from "lodash";
import { currentTaskSectionIndexAtom } from "recoil/currentTaskSectionIndexAtom";
import { removeTab } from "../logics";
import useGetTaskTitleFromTaskKey from "hooks/useGetTaskTitleFromTaskKey";
import { isBrowser } from "react-device-detect";

export default function TabContent({
  index,
  taskKey,
}: {
  index: number;
  taskKey: string;
}) {
  const title = useGetTaskTitleFromTaskKey(taskKey);
  const [taskSectionState, setTaskSectionState] =
    useRecoilState(taskSectionAtom);
  const { openTaskKeyList, currentTaskKey } = (taskSectionState || [])[index];
  const [showCloseButton, setShowCloseButton] = useState<boolean>(false);

  const setCurrentTaskSectionIndex = useSetRecoilState(
    currentTaskSectionIndexAtom
  );

  return (
    <div
      onMouseOver={(e) => {
        if (isBrowser) {
          setShowCloseButton(true);
        }
      }}
      onMouseLeave={() => {
        if (isBrowser) {
          setShowCloseButton(false);
        }
      }}
    >
      <Stack
        direction={"row"}
        justifyContent="space-between"
        alignItems={"center"}
        className={`shrink-0 cursor-pointer w-[180px] py-[6px] pl-[24px] pr-[4px]`}
        onClick={() => {
          if (taskSectionState) {
            const copy = _.cloneDeep(taskSectionState);
            copy[index] = {
              ...copy[index],
              currentTaskKey: taskKey,
            };
            setTaskSectionState(copy);
          }
        }}
      >
        <Typography
          level={"body-xs"}
          sx={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: "1",
            WebkitBoxOrient: "vertical",
          }}
        >
          {title}
        </Typography>

        {(currentTaskKey === taskKey || showCloseButton) && (
          <div
            onClick={(e) => {
              e.stopPropagation();
              removeTab(
                currentTaskKey,
                openTaskKeyList,
                taskKey,
                setTaskSectionState,
                setCurrentTaskSectionIndex,
                index
              );
            }}
            className="flex items-center"
          >
            <span
              style={{ fontSize: "22px", opacity: 0.4 }}
              className="material-symbols-rounded"
            >
              close
            </span>
          </div>
        )}
      </Stack>
    </div>
  );
}
